// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2imOv","range":"MonthRangeSwitch_range__1mm10","disabled":"MonthRangeSwitch_disabled__3ioNm"};